import { Controller } from "@hotwired/stimulus"

// Generic polling controller — refreshes the Turbo Frame it's attached to
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 }, url: String }

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.src = this.urlValue
    }
  }
}
